import axios from "axios";
import database from "../../database/database";
import isNull from "../../mixin/isNull";

/**
 * @rule-checker exclude
 * @returns {{exchangeCode(*): Promise<boolean|*|undefined>, refresh(): Promise<boolean|undefined>, logout(): Promise<*|undefined>, userinfo(): Promise<any|null|undefined>}|*|null|boolean}
 */
export default function () {
    const redirect = () => {
        database.write(database.TABLE_ROUTING, "after_auth", window.location.pathname);
        window.location.replace(process.env.REACT_APP_AWS_AUTH_PAGE.replace("{clientId}", process.env.REACT_APP_AWS_CLIENT_ID).replace("{redirectUri}", process.env.REACT_APP_AWS_REDIRECT_URI));
    }

    return {
        async exchangeCode(code) {
            try {
                const response = await axios.post(process.env.REACT_APP_API_URL + "/service-auth/idp/session/exchange-code", {
                    idp: {
                        client_id: process.env.REACT_APP_AWS_CLIENT_ID,
                        redirect_uri: process.env.REACT_APP_AWS_REDIRECT_URI,
                        code: code
                    }
                });

                database.write(database.TABLE_AUTHENTICATION, "exp", response.data.exp);

                return true;
            } catch (e) {
                redirect();
                return e.response?.data?.message;
            }
        },
        async refresh() {
            try {
                const response = await axios.post(process.env.REACT_APP_API_URL + "/service-auth/idp/session/refresh");
                database.write(database.TABLE_AUTHENTICATION, "exp", response.data.exp);

                return true;
            } catch (e) {
                // Pas de réponse = erreur réseau (typique au réveil mobile, radio pas encore reconnectée).
                // La session côté serveur est intacte : on ne déconnecte pas, on retentera.
                if (isNull(e?.response)) {
                    return false;
                }

                // Session réellement invalide → déconnexion légitime.
                if (isAuthError(e.response.status)) {
                    redirect();
                }

                return false;
            }
        },
        async logout() {
            try {
                await axios.post(process.env.REACT_APP_API_URL + "/service-auth/idp/session/logout");
                redirect();
            } catch (e) {
                return e.response?.data?.message;
            }
        },
        async userinfo() {
            try {
                const response = await axios.get(process.env.REACT_APP_API_URL + "/service-auth/idp/identities/userinfo");
                return response.data;
            } catch (e) {
                // Erreur réseau (pas de réponse) → on ne déconnecte pas, on renvoie null : l'appelant gère.
                if (isNull(e?.response)) {
                    return null;
                }

                // Session réellement invalide → déconnexion légitime.
                if (isAuthError(e.response.status)) {
                    redirect();
                }

                return null;
            }
        }
    }
}

function isAuthError(status) {
    return status === 400 || status === 401 || status === 403;
}